module.exports = __webpack_public_path__ + "amcharts/images/eraserIconH.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/eraserIconH.gif
// module id = 265
// module chunks = 0